import { createContext } from "react";
const PortalContext = /*#__PURE__*/ createContext(null);
export { PortalContext };
